import { Record, List, fromJS } from 'immutable';
import _ from 'lodash';

import Deed from '../deed/model';

const properties = {
  id: '',
  requireLogin: false,
  isSurvey: false,
  name: '',
  subtitle: '',
  description: '',
  confirmationText: '',
  document: '',
  questions: List(),
  responses: List(),
  responsesAggregation: [],
  responsesCount: Number(0),
  deeds: List(),
  organization: '',
};

export default class Form extends Record(properties, 'Form') {
  public readonly id!: string;

  public readonly requireLogin!: boolean;

  public readonly isSurvey!: boolean;

  public readonly name!: string;

  public readonly subtitle!: string;

  public readonly description!: string;

  public readonly confirmationText!: string;

  public readonly document!: string;

  public readonly questions!: any[];

  public readonly responses!: any[];

  public readonly responsesAggregation!: any[];

  public readonly responsesCount!: number;

  public readonly deeds!: Deed[];

  public readonly organization!: string;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      questions: fromJS(values.questions),
      responses: fromJS(values.responses),
      deeds: fromJS(values.deeds),
    });
  }
}
